import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[(_vm.loading)?_c('loading-view'):_c('main-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }